import {FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {Country, IGeographicalEntity} from "../../../../core/models/geography.model";

export interface ILocationForm {
    name: FormControl<string>;
    country: FormControl<Country | string>;
    state: FormControl<IGeographicalEntity | string>;

}

export class LocationFormFactory {
    public static create(): FormGroup<ILocationForm> {
        return new FormGroup<ILocationForm>({
            name: new FormControl<string>("", [Validators.required]),
            country: new FormControl<Country | string>(null, [(control => typeof control.value === "string" && control.value.length > 0 ? {noneSelected: true} : null) as ValidatorFn]),
            state: new FormControl<IGeographicalEntity | string>(null, [(control => typeof control.value === "string" && control.value.length > 0 ? {noneSelected: true} : null) as ValidatorFn])
        })
    }
}
